import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
    createStyles({
        initialDialogPaper: {
            width: 530,
            maxWidth: 530,
            borderRadius: 4,
        },
        expandedDialogPaper: {
            borderRadius: 4,
        },
        title: {
            fontWeight: 700,
            fontSize: 24,
            lineHeight: '30px',
            padding: theme.spacing(2, 3, 1, 3),
            '& .MuiTypography-root': {
                fontWeight: 700,
            },
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1.5),
            top: theme.spacing(1.5),
            color: theme.palette.grey[500],
        },
        closeButtonExpanded: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(0.5),
            color: theme.palette.grey[500],
            zIndex: 2,
        },
        initialDialogContent: {
            padding: theme.spacing(0, 3, 2, 3),
        },
        expandedDialogContent: {
            backgroundColor: '#F2F5F7',
            padding: theme.spacing(2, 3.5, 1.5, 3.5),
        },
        initialDescription: {
            color: '#2D2D2D',
            marginBottom: theme.spacing(1.5),
            fontSize: 16,
            lineHeight: '22px',
        },
        documentsSectionSpacedTop: {
            marginTop: theme.spacing(2.5),
        },
        documentsSectionHeader: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(0.1),
        },
        documentsSectionTitle: {
            fontWeight: 600,
            fontSize: 15,
            color: '#107A98',
            marginBottom: theme.spacing(0.15),
        },
        filtersContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            marginBottom: theme.spacing(2),
        },
        filterLabel: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.75),
            color: '#4D575E',
            marginBottom: 0,
            marginTop: 0,
            '& .MuiCheckbox-root': {
                paddingTop: 1,
                paddingBottom: 1,
            },
            '& .MuiFormControlLabel-label': {
                fontSize: 14,
                lineHeight: 1.1,
            },
        },
        selectAllLabel: {
            marginBottom: 0,
        },
        documentTypeLabel: {
            marginTop: -4,
        },
        tableTitle: {
            fontWeight: 600,
            color: '#107A98',
            marginBottom: theme.spacing(1),
        },
        tableContainer: {
            border: '1px solid #D6DDE2',
            borderRadius: 4,
            backgroundColor: '#FFFFFF',
            padding: theme.spacing(1, 1, 0.5, 1),
            minHeight: 0,
            marginBottom: theme.spacing(2),
            '& .MuiTableCell-root': {
                paddingTop: 4,
                paddingBottom: 4,
            },
            '& thead .MuiTableCell-root': {
                paddingTop: 0,
                paddingBottom: 0,
                lineHeight: 1.05,
                fontSize: 13,
            },
            '& thead .MuiCheckbox-root': {
                paddingTop: 0,
                paddingBottom: 0,
            },
            '& thead .MuiTableSortLabel-root': {
                margin: 0,
                lineHeight: 1,
            },
            '& thead .MuiTableRow-root': {
                height: 18,
            },
            '& thead .MuiTableCell-head': {
                height: 18,
                minHeight: 18,
            },
            '& tbody .MuiTableRow-root': {
                height: 25,
            },
        },
        actions: {
            padding: theme.spacing(0, 2, 1.5, 2),
            marginTop: theme.spacing(1),
        },
        primaryButton: {
            backgroundColor: '#107A98',
            textTransform: 'uppercase',
            minWidth: 72,
            height: 36,
            fontWeight: 600,
            '&:hover': {
                backgroundColor: '#004763',
            },
        },
        secondaryButton: {
            color: '#107A98',
            borderColor: '#107A98',
            textTransform: 'uppercase',
            minWidth: 100,
            height: 36,
            fontWeight: 600,
        },
        siuExpandedTitle: {
            backgroundColor: '#107A98',
            color: '#FFFFFF',
            padding: theme.spacing(2, 5, 2, 3),
            position: 'relative',
            margin: 0,
        },
        siuExpandedTitleText: {
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: 20,
            lineHeight: '26px',
        },
        siuExpandedCloseButton: {
            position: 'absolute',
            right: theme.spacing(0.5),
            top: theme.spacing(0.5),
            color: '#FFFFFF',
        },
        rushRow: {
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(0.5),
            color: '#4D575E',
        },
        sectionTitleTeal: {
            fontWeight: 600,
            fontSize: 15,
            color: '#107A98',
            marginBottom: theme.spacing(1),
        },
        requiredMark: {
            color: '#e74c3c',
        },
        fieldValidationError: {
            color: '#e74c3c',
            display: 'block',
            marginTop: theme.spacing(-2),
            marginBottom: theme.spacing(1.5),
        },
        commentsFieldWrap: {
            position: 'relative',
            marginBottom: theme.spacing(2.5),
        },
        commentsTextField: {
            backgroundColor: '#FFFFFF',
        },
        charCounter: {
            position: 'absolute',
            right: theme.spacing(1.5),
            bottom: theme.spacing(1),
            color: '#6B7780',
        },
        documentTypesColumnFlow: {
            marginBottom: theme.spacing(1),
            columnCount: 1,
            columnGap: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                columnCount: 3,
            },
        },
        documentTypesColumnItem: {
            breakInside: 'avoid',
            pageBreakInside: 'avoid',
            WebkitColumnBreakInside: 'avoid',
        },
        dateRangeBlock: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(1),
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(0.5),
            breakInside: 'avoid',
            pageBreakInside: 'avoid',
        },
        dateRangeFieldWrap: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            flex: '1 1 130px',
            minWidth: 140,
        },
        dateRangeFieldLabel: {
            display: 'block',
            marginBottom: theme.spacing(0.5),
            fontSize: 13,
            lineHeight: 1.2,
            fontWeight: 500,
            color: '#4D575E',
        },
        dateRangeInput: {
            backgroundColor: '#FFFFFF',
        },
        searchDocumentsRow: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: theme.spacing(2),
        },
        searchDocumentsButton: {
            textTransform: 'none',
            minWidth: 140,
            height: 36,
            backgroundColor: '#FFFFFF',
            fontWeight: 600,
        },
        footerActionsBar: {
            padding: theme.spacing(1.5, 2, 1.5, 2),
            marginTop: theme.spacing(1),
            backgroundColor: '#FFFFFF',
            borderTop: '1px solid #DCE3E8',
            boxShadow: '0 -3px 8px rgba(16, 122, 152, 0.12)',
        },
    }),
);
